/**
 * Initialize Tippy.js
 */

;(function($) {

    // Initialize Tippy tooltips
    tippy('[data-tippy-content]', {
        touch: true, // Show on long press (500ms)
        trigger: 'mouseenter focus click', // Show on hover, focus, and tap
        interactive: true // Allow interacting with tooltip content
    });

    // Remove title attribute where tooltip is present
    $( '[data-tippy-content]' ).each( function() {
        $( this ).removeAttr( 'title' );
    });

})( window.jQuery );
